import { accent } from "../hooks/tokens.js";
import { ARTICLES } from "../data.js";

// Écran cours : module courant, leçons, et le quiz de module (le même moteur
// de quiz — activeQuizDomain/domainQuestions/quizQ, calculés dans
// useNetdoc.js — sert aussi à la pratique par domaine lancée depuis Certif).
export function buildCourseView(ctx) {
  const {
    s, patch, go, syncLesson, setModule, startQuiz, syncQuizSession,
    course, moduleIdx, curModule, lessonsData, isLessonDone, doneCount, firstTodo,
    curDomainId, doneKey, lessonKey, attemptedDomain,
    activeQuizDomain, domainQuestions, quizQ, quizFinished,
  } = ctx;

  return {
    courseLabel: course.label,
    courseModuleLabel: "Parcours " + course.label + " · Module " + (moduleIdx + 1) + " / " + course.modules.length,
    courseTitle: curModule.title,
    courseDesc: curModule.desc,
    courseMeta: curModule.duration + " · " + lessonsData.length + " leçon" + (lessonsData.length > 1 ? "s" : "") + " · Prérequis : " + curModule.prereq,
    lessons: lessonsData.map((l) => {
      const done = isLessonDone(l);
      return { ...l, mark: done ? "✓" : String(l.n),
        ring: done ? accent : "oklch(0.88 0.01 85)",
        fill: done ? accent : "transparent",
        numColor: done ? "oklch(0.98 0.005 85)" : "oklch(0.55 0.015 60)",
        state: done ? "Terminé" : (firstTodo && firstTodo.n === l.n ? "Reprendre" : "À faire"),
        onClick: () => {
          const key = doneKey(course.id, moduleIdx, l.n);
          patch({ done: { ...s.done, [key]: !done } });
          syncLesson(course.id, lessonKey(moduleIdx, l.n), !done);
        } };
    }),
    modulePct: Math.round((doneCount / lessonsData.length) * 100),
    progressNote: doneCount + " leçon" + (doneCount > 1 ? "s" : "") + " sur " + lessonsData.length + " terminée" + (doneCount > 1 ? "s" : "") + (attemptedDomain(curDomainId) ? ". Quiz tenté." : ". Quiz non tenté."),
    resumeLabel: firstTodo ? "Reprendre la leçon " + firstTodo.n : "Passer au quiz",
    resumeLesson: () => { if (firstTodo) go(firstTodo.link); },
    quizCounter: !s.quizDomainId ? "Quiz du module" : quizFinished ? "Terminé" : "Question " + (s.quizIdx + 1) + " / " + domainQuestions.length,
    quizQuestion: !s.quizDomainId
      ? "Ce module comporte " + domainQuestions.length + " questions. Score requis : 70 %."
      : quizFinished
        ? "Score : " + s.quizCorrect + " / " + domainQuestions.length + " (" + Math.round((s.quizCorrect / domainQuestions.length) * 100) + " %)."
        : (quizQ ? quizQ.prompt : ""),
    quizChoices: (!s.quizDomainId || quizFinished || !quizQ) ? [] : quizQ.choices.map((c) => {
      const sel = s.quizAnswer === c.k;
      const right = s.quizChecked && c.k === quizQ.answer;
      const wrong = s.quizChecked && sel && c.k !== quizQ.answer;
      return { ...c,
        border: right ? accent : wrong ? "oklch(0.78 0.012 60)" : sel ? accent : "oklch(0.92 0.008 85)",
        bg: right ? "oklch(0.98 0.006 60)" : "transparent",
        mark: right ? "Bonne réponse" : wrong ? "Incorrect" : "",
        markColor: right ? accent : "oklch(0.55 0.015 60)",
        onClick: () => { if (!s.quizChecked) patch({ quizAnswer: c.k }); } };
    }),
    quizButton: !s.quizDomainId ? "Commencer le quiz"
      : quizFinished ? "Recommencer"
      : !s.quizChecked ? "Valider"
      : (s.quizIdx + 1 >= domainQuestions.length ? "Voir le score" : "Question suivante"),
    quizPrimary: () => {
      if (!s.quizDomainId) { startQuiz(curDomainId); return; }
      if (quizFinished) { startQuiz(activeQuizDomain); return; }
      if (!s.quizChecked) {
        if (!s.quizAnswer) return;
        const correct = s.quizAnswer === quizQ.answer;
        patch({ quizChecked: true, quizCorrect: s.quizCorrect + (correct ? 1 : 0) });
        return;
      }
      const nextIdx = s.quizIdx + 1;
      if (nextIdx >= domainQuestions.length) {
        const correctCount = s.quizCorrect, totalCount = domainQuestions.length;
        const scorePct = Math.round((correctCount / totalCount) * 100);
        patch((prev) => ({ quizIdx: nextIdx, quizSessions: [...prev.quizSessions, { domainId: activeQuizDomain, scorePct, correctCount, totalCount, completedAt: new Date().toISOString() }] }));
        syncQuizSession(activeQuizDomain, correctCount, totalCount);
      } else {
        patch({ quizIdx: nextIdx, quizAnswer: null, quizChecked: false });
      }
    },
    quizFeedback: !s.quizDomainId || quizFinished ? ""
      : !s.quizChecked ? (s.quizAnswer ? "" : "Choisissez une réponse.")
      : (s.quizAnswer === quizQ.answer ? "Exact : " + quizQ.explanation : "Non : " + quizQ.explanation),
    quizFeedbackColor: s.quizChecked ? (s.quizAnswer === (quizQ && quizQ.answer) ? accent : "oklch(0.4 0.015 60)") : "oklch(0.55 0.015 60)",
    modules: course.modules.map((m, i) => {
      const total = m.lessons.length;
      const done = m.lessons.filter((l) => s.done[doneKey(course.id, i, l.n)]).length;
      return { n: String(i + 1).padStart(2, "0"), title: m.title, state: Math.round((done / total) * 100) + " %",
        color: i === moduleIdx ? accent : "oklch(0.4 0.015 60)",
        onClick: () => setModule(i) };
    }),
    relatedArticles: ["bgp-attrs", "redistribution", "ospf-lsa"].map((id) => {
      const a = ARTICLES.find((x) => x.id === id);
      return { title: a.title, onClick: () => go(id) };
    }),
  };
}
